const blogsColumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "imageUrl",
    label: "Image",
  },
  {
    key: "name",
    label: "Title",
  },

  {
    key: "date",
    label: "Date",
  },

  {
    key: "actions",
    label: "Actions",
  },
];

export { blogsColumn };
